import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal'

import {DialogComponent} from './dialog.component'

@Injectable()
export class ModalService {
  bsModalRef: BsModalRef

  constructor(private bsModalService: BsModalService) {}

  show(template, options = {}): BsModalRef {
    return this.bsModalService.show(template, options)
  }
  close() {
    this.bsModalService.hide()
  }

  dialog(
    title: string,
    message: string,
    options: string[],
  ): Observable<string> {
    const initialState = {
      title: title,
      message: message,
      options: options,
      answer: '',
    }
    this.bsModalRef = this.bsModalService.show(DialogComponent, {initialState})

    return new Observable<string>(this.getConfirmSubscriber())
  }

  confirm(title: string, message: string): Observable<boolean> {
    return this.dialog(title, message, ['Ok', 'Cancel']).pipe(
      map((answer) => {
        return answer === 'Ok'
      }),
    )
  }

  private getConfirmSubscriber() {
    return (observer) => {
      const subscription = this.bsModalService.onHidden.subscribe(
        (reason: string) => {
          observer.next(this.bsModalRef.content.answer)
          observer.complete()
        },
      )

      return {
        unsubscribe() {
          subscription.unsubscribe()
        },
      }
    }
  }
}
